module.exports = __webpack_public_path__ + "static/media/mp3.d936dcec.svg";